module.exports = __webpack_public_path__ + "static/media/AnimationsGoodOptimized.36489147.jp2";